import React from 'react';
import PropTypes from 'prop-types';
import SvgSymbol from 'common/components/svg-symbol';
import HelptextTooltip from 'common/components/helptext-tooltip';
import './index.scss';

export default class Cell extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    data: PropTypes.object,
    tdAttributes: PropTypes.object,
  };

  getContents() {
    const contents = (
      <span className={'Cell--contents'}>
        {this.getSvg()}
        {this.getText()}
        {this.getTooltip()}
      </span>
    );
    const {href} = this.props.data;
    return !href ? (
      contents
    ) : (
      <a className={'Cell--link'} href={href}>
        {contents}
      </a>
    );
  }

  getSvg() {
    const {icon} = this.props.data;
    return !icon ? null : <SvgSymbol className={'Cell--icon'} name={icon} />;
  }

  getTdAttributes() {
    const attributes = this.props.tdAttributes || {};

    let {className} = attributes;

    if (!className) {
      className = 'Cell';
    } else {
      className += ' Cell';
    }

    return {
      ...attributes,
      className,
    };
  }

  getText() {
    return <span className={'Cell--text'}>{this.props.data.text}</span>;
  }

  getTooltip() {
    const {helptext} = this.props.data;
    return helptext ? <HelptextTooltip>{helptext}</HelptextTooltip> : null;
  }

  render() {
    return this.props.children !== undefined ? (
      <td {...this.getTdAttributes()}>{this.props.children}</td>
    ) : (
      <td {...this.getTdAttributes()}>{this.getContents()}</td>
    );
  }
}
